import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setIsOpen(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <h1>MeowBox Studios</h1>
        </Link>
        <button 
          className={`nav-toggle ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={isActive('/') ? 'active' : ''}
              onClick={closeMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/games" 
              className={isActive('/games') ? 'active' : ''}
              onClick={closeMenu}
            >
              Games
            </Link>
          </li>
          <li>
            <Link 
              to="/team" 
              className={isActive('/team') ? 'active' : ''}
              onClick={closeMenu}
            >
              Team
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={isActive('/about') ? 'active' : ''}
              onClick={closeMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link 
              to="/careers" 
              className={isActive('/careers') ? 'active' : ''}
              onClick={closeMenu}
            >
              Careers
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
